// DO NOT EDIT -- generated from fs/services/pie/spotlight.proto

import * as alexa from '../alexa';
import * as display from '../webber/frontend/display';
import * as metrics from '../../api/metrics';
import * as pagination from '../../shared/pagination';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';

export namespace IssueServicePublic {

  export const GetIssuesListViewEndpoint = "/grpc/pie.IssueServicePublic/GetIssuesListView";
  export function GetIssuesListView(sender: (req: GetIssuesListViewRequest, endpoint: string) => Promise<GetIssuesListViewResponse>, req: GetIssuesListViewRequest): { promise: () => Promise<GetIssuesListViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIssuesListViewEndpoint),
      endpoint: GetIssuesListViewEndpoint
    };
  }

  export const GetIssueDetailViewEndpoint = "/grpc/pie.IssueServicePublic/GetIssueDetailView";
  export function GetIssueDetailView(sender: (req: GetIssueDetailViewRequest, endpoint: string) => Promise<GetIssueDetailViewResponse>, req: GetIssueDetailViewRequest): { promise: () => Promise<GetIssueDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIssueDetailViewEndpoint),
      endpoint: GetIssueDetailViewEndpoint
    };
  }

  export const UpdateSeverityEndpoint = "/grpc/pie.IssueServicePublic/UpdateSeverity";
  export function UpdateSeverity(sender: (req: UpdateSeverityRequest, endpoint: string) => Promise<UpdateSeverityResponse>, req: UpdateSeverityRequest): { promise: () => Promise<UpdateSeverityResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSeverityEndpoint),
      endpoint: UpdateSeverityEndpoint
    };
  }

  export const GetIssueSeverityHistoryEndpoint = "/grpc/pie.IssueServicePublic/GetIssueSeverityHistory";
  export function GetIssueSeverityHistory(sender: (req: GetIssueSeverityHistoryRequest, endpoint: string) => Promise<GetIssueSeverityHistoryResponse>, req: GetIssueSeverityHistoryRequest): { promise: () => Promise<GetIssueSeverityHistoryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIssueSeverityHistoryEndpoint),
      endpoint: GetIssueSeverityHistoryEndpoint
    };
  }

  export const UpdateIssueStatusEndpoint = "/grpc/pie.IssueServicePublic/UpdateIssueStatus";
  export function UpdateIssueStatus(sender: (req: UpdateIssueStatusRequest, endpoint: string) => Promise<UpdateIssueStatusResponse>, req: UpdateIssueStatusRequest): { promise: () => Promise<UpdateIssueStatusResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateIssueStatusEndpoint),
      endpoint: UpdateIssueStatusEndpoint
    };
  }

  export const UpdateIssueAssignedToEndpoint = "/grpc/pie.IssueServicePublic/UpdateIssueAssignedTo";
  export function UpdateIssueAssignedTo(sender: (req: UpdateIssueAssignedToRequest, endpoint: string) => Promise<UpdateIssueAssignedToResponse>, req: UpdateIssueAssignedToRequest): { promise: () => Promise<UpdateIssueAssignedToResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateIssueAssignedToEndpoint),
      endpoint: UpdateIssueAssignedToEndpoint
    };
  }

  export const GetInsightNotesEndpoint = "/grpc/pie.IssueServicePublic/GetInsightNotes";
  export function GetInsightNotes(sender: (req: GetInsightNotesRequest, endpoint: string) => Promise<GetInsightNotesResponse>, req: GetInsightNotesRequest): { promise: () => Promise<GetInsightNotesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInsightNotesEndpoint),
      endpoint: GetInsightNotesEndpoint
    };
  }

  export const CreateNoteEndpoint = "/grpc/pie.IssueServicePublic/CreateNote";
  export function CreateNote(sender: (req: CreateNoteRequest, endpoint: string) => Promise<InsightNote>, req: CreateNoteRequest): { promise: () => Promise<InsightNote>, endpoint: string } {
    return {
      promise: () => sender(req, CreateNoteEndpoint),
      endpoint: CreateNoteEndpoint
    };
  }

  export const UpdateNoteEndpoint = "/grpc/pie.IssueServicePublic/UpdateNote";
  export function UpdateNote(sender: (req: UpdateNoteRequest, endpoint: string) => Promise<InsightNote>, req: UpdateNoteRequest): { promise: () => Promise<InsightNote>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateNoteEndpoint),
      endpoint: UpdateNoteEndpoint
    };
  }

  export const DeleteNoteEndpoint = "/grpc/pie.IssueServicePublic/DeleteNote";
  export function DeleteNote(sender: (req: DeleteNoteRequest, endpoint: string) => Promise<{}>, req: DeleteNoteRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteNoteEndpoint),
      endpoint: DeleteNoteEndpoint
    };
  }

  export const GetInstanceRenderArgsEndpoint = "/grpc/pie.IssueServicePublic/GetInstanceRenderArgs";
  export function GetInstanceRenderArgs(sender: (req: GetInstanceRenderArgsRequest, endpoint: string) => Promise<GetInstanceRenderArgsResponse>, req: GetInstanceRenderArgsRequest): { promise: () => Promise<GetInstanceRenderArgsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInstanceRenderArgsEndpoint),
      endpoint: GetInstanceRenderArgsEndpoint
    };
  }

  export const CreateInsightIgnoreRuleEndpoint = "/grpc/pie.IssueServicePublic/CreateInsightIgnoreRule";
  /** Ignore rules are creatable for Architects and above. */
  export function CreateInsightIgnoreRule(sender: (req: CreateInsightIgnoreRuleRequest, endpoint: string) => Promise<{}>, req: CreateInsightIgnoreRuleRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateInsightIgnoreRuleEndpoint),
      endpoint: CreateInsightIgnoreRuleEndpoint
    };
  }

  export const DeleteInsightIgnoreRuleEndpoint = "/grpc/pie.IssueServicePublic/DeleteInsightIgnoreRule";
  /** Ignore rules are deletable for Architects and above. */
  export function DeleteInsightIgnoreRule(sender: (req: DeleteInsightIgnoreRuleRequest, endpoint: string) => Promise<{}>, req: DeleteInsightIgnoreRuleRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteInsightIgnoreRuleEndpoint),
      endpoint: DeleteInsightIgnoreRuleEndpoint
    };
  }

  export const GetInsightIgnoreRulesEndpoint = "/grpc/pie.IssueServicePublic/GetInsightIgnoreRules";
  export function GetInsightIgnoreRules(sender: (req: GetInsightIgnoreRulesRequest, endpoint: string) => Promise<GetInsightIgnoreRulesResponse>, req: GetInsightIgnoreRulesRequest): { promise: () => Promise<GetInsightIgnoreRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInsightIgnoreRulesEndpoint),
      endpoint: GetInsightIgnoreRulesEndpoint
    };
  }

  export const PreviewInsightIgnoreRuleEndpoint = "/grpc/pie.IssueServicePublic/PreviewInsightIgnoreRule";
  export function PreviewInsightIgnoreRule(sender: (req: PreviewInsightIgnoreRuleRequest, endpoint: string) => Promise<PreviewInsightIgnoreRuleResponse>, req: PreviewInsightIgnoreRuleRequest): { promise: () => Promise<PreviewInsightIgnoreRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, PreviewInsightIgnoreRuleEndpoint),
      endpoint: PreviewInsightIgnoreRuleEndpoint
    };
  }
}

export namespace IssueAdminService {

  export const GenerateThumbnailForIssueInstanceEndpoint = "/grpc/pie.IssueAdminService/GenerateThumbnailForIssueInstance";
  /** GenerateThumbnailForIssueInstance will request for thumbnails to regenerate the image for the given issue instance */
  export function GenerateThumbnailForIssueInstance(sender: (req: GenerateThumbnailForIssueInstanceRequest, endpoint: string) => Promise<GenerateThumbnailForIssueInstanceResponse>, req: GenerateThumbnailForIssueInstanceRequest): { promise: () => Promise<GenerateThumbnailForIssueInstanceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateThumbnailForIssueInstanceEndpoint),
      endpoint: GenerateThumbnailForIssueInstanceEndpoint
    };
  }

  export const GenerateInsightEndpoint = "/grpc/pie.IssueAdminService/GenerateInsight";
  /**
   * GenerateInsight will publish a task to generate an insight for the given proactive metric. It will skip the generators
   * logic, but it will test the secondary heuristic logic. There are a few secondary heuristics which are skipped using gcloud.Env().IsDevMode().
   * This API is only intended for local testing purposes. Taskadmin can be used for higher envs.
   */
  export function GenerateInsight(sender: (req: GenerateInsightRequest, endpoint: string) => Promise<{}>, req: GenerateInsightRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateInsightEndpoint),
      endpoint: GenerateInsightEndpoint
    };
  }

  export const BackfillSpotlightInsightsEndpoint = "/grpc/pie.IssueAdminService/BackfillSpotlightInsights";
  /**
   * BackfillSpotlightInsights will just load the db with dummy insights. It will populate the various versions of insights
   * the db needs to support over time. This is only intended for local testing purposes.
   */
  export function BackfillSpotlightInsights(sender: (req: BackfillSpotlightInsightsRequest, endpoint: string) => Promise<{}>, req: BackfillSpotlightInsightsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BackfillSpotlightInsightsEndpoint),
      endpoint: BackfillSpotlightInsightsEndpoint
    };
  }

  export const GetInsightInstanceEndpoint = "/grpc/pie.IssueAdminService/GetInsightInstance";
  export function GetInsightInstance(sender: (req: GetInsightInstanceRequest, endpoint: string) => Promise<GetInsightInstanceResponse>, req: GetInsightInstanceRequest): { promise: () => Promise<GetInsightInstanceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInsightInstanceEndpoint),
      endpoint: GetInsightInstanceEndpoint
    };
  }

  export const GenerateFunnelInsightEndpoint = "/grpc/pie.IssueAdminService/GenerateFunnelInsight";
  /**
   * GenerateFunnelInsight will publish a task to generate a funnel insight.
   * This API is only intended for local testing purposes. Taskadmin can be used for higher envs.
   */
  export function GenerateFunnelInsight(sender: (req: GenerateFunnelInsightRequest, endpoint: string) => Promise<{}>, req: GenerateFunnelInsightRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateFunnelInsightEndpoint),
      endpoint: GenerateFunnelInsightEndpoint
    };
  }

  export const GetInsightIgnoreRulesEndpoint = "/grpc/pie.IssueAdminService/GetInsightIgnoreRules";
  /** Admin API to get the ignore rules for any org */
  export function GetInsightIgnoreRules(sender: (req: GetInsightIgnoreRulesRequest, endpoint: string) => Promise<GetInsightIgnoreRulesResponse>, req: GetInsightIgnoreRulesRequest): { promise: () => Promise<GetInsightIgnoreRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInsightIgnoreRulesEndpoint),
      endpoint: GetInsightIgnoreRulesEndpoint
    };
  }

  export const CreateInsightIgnoreRuleEndpoint = "/grpc/pie.IssueAdminService/CreateInsightIgnoreRule";
  export function CreateInsightIgnoreRule(sender: (req: CreateInsightIgnoreRuleRequest, endpoint: string) => Promise<{}>, req: CreateInsightIgnoreRuleRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateInsightIgnoreRuleEndpoint),
      endpoint: CreateInsightIgnoreRuleEndpoint
    };
  }

  export const DeleteInsightIgnoreRuleEndpoint = "/grpc/pie.IssueAdminService/DeleteInsightIgnoreRule";
  /** Ignore rules are deletable for Architects and above. */
  export function DeleteInsightIgnoreRule(sender: (req: DeleteInsightIgnoreRuleRequest, endpoint: string) => Promise<{}>, req: DeleteInsightIgnoreRuleRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteInsightIgnoreRuleEndpoint),
      endpoint: DeleteInsightIgnoreRuleEndpoint
    };
  }

  export const IsInsightIgnoredEndpoint = "/grpc/pie.IssueAdminService/IsInsightIgnored";
  export function IsInsightIgnored(sender: (req: IsInsightIgnoredRequest, endpoint: string) => Promise<IsInsightIgnoredResponse>, req: IsInsightIgnoredRequest): { promise: () => Promise<IsInsightIgnoredResponse>, endpoint: string } {
    return {
      promise: () => sender(req, IsInsightIgnoredEndpoint),
      endpoint: IsInsightIgnoredEndpoint
    };
  }

  export const ResetWorkflowsEndpoint = "/grpc/pie.IssueAdminService/ResetWorkflows";
  /** ResetWorkflows will reset failed Temporal workflows for the given namespace, workflow type, and time range. */
  export function ResetWorkflows(sender: (req: ResetWorkflowsRequest, endpoint: string) => Promise<ResetWorkflowsResponse>, req: ResetWorkflowsRequest): { promise: () => Promise<ResetWorkflowsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ResetWorkflowsEndpoint),
      endpoint: ResetWorkflowsEndpoint
    };
  }
}

export interface ResetWorkflowsRequest {
  /** Temporal namespace to reset workflows for. */
  namespace: string;
  /** Workflow type to reset. */
  workflowType: WorkflowType;
  /** Maximum number of workflows to reset. */
  maxWorkflows: number;
  /** Time range of failed workflows to reset. */
  timeRange: ResetWorkflowsRequest.TimeRange | null;
}

export namespace ResetWorkflowsRequest {
  export interface TimeRange {
    startTime: protobuf.timestamp | null;
    endTime: protobuf.timestamp | null;
  }
}

export interface ResetWorkflowsResponse {
  resetCount: number;
}

export enum WorkflowType {
  WORKFLOW_TYPE_INVALID = 0,
  WORKFLOW_TYPE_NEW_INSIGHT = 1
}

export interface GetInsightInstanceRequest {
  orgId: string;
  instanceId: string;
  issueId: string;
}

export interface GetInsightInstanceResponse {
  insightId: string;
  instanceId: string;
  orgId: string;
  defaultMetricId: string;
  groupId: string;
  groupIdFallback: boolean;
  endTime: protobuf.timestamp | null;
  unnamedMetricHash: string;
  title: string;
  insightType: InsightType;
  insightDescription: string;
  percentChange: number;
  spikingValue: number;
}

export interface GenerateThumbnailForIssueInstanceRequest {
  orgId: string;
  instanceId: string;
}

export interface GenerateThumbnailForIssueInstanceResponse {
  thumbnailPath: string;
}

export interface GetIssueSeverityHistoryRequest {
  issueId: string;
  orgId: string;
}

export interface GetIssueSeverityHistoryResponse {
  severities: SeverityInfo[];
}

export interface GetIssuesListViewRequest {
  orgId: string;
  startTime: protobuf.timestamp | null;
  pageIds: string[];
  funnelIds: string[];
  domainNames: string[];
  appNames: string[];
  severities: Severity[];
  status: IssueStatus[];
}

export interface SimpleFilter {
  id: string;
  name: string;
}

export interface GetIssuesListViewResponse {
  issues: IssueListRow[];
  funnels: SimpleFilter[];
  pages: SimpleFilter[];
  domainNames: string[];
  appNames: string[];
  severities: Severity[];
  status: IssueStatus[];
}

export enum Severity {
  SEVERITY_INVALID = 0,
  SEVERITY_LOW = 1,
  SEVERITY_MEDIUM = 2,
  SEVERITY_HIGH = 3,
  SEVERITY_CRITICAL = 4,
  SEVERITY_NOT_AN_ISSUE = 5
}

export enum SeveritySource {
  INVALID = 0,
  FULLSTORY = 1,
  USER = 2
}

export enum IssueStatus {
  STATUS_NOT_SET = 0,
  INVESTIGATING = 1,
  TICKET_OPENED = 2,
  FIX_IN_PROGRESS = 3,
  RESOLVED = 4,
  WILL_NOT_FIX = 5,
  REOPENED = 6
}

export interface UpdateIssueStatusRequest {
  orgId: string;
  insightId: string;
  newStatus: IssueStatus;
  statisticsId: string;
}

export interface UpdateIssueStatusResponse {
  status: IssueStatus;
}

export interface UpdateIssueAssignedToRequest {
  orgId: string;
  insightId: string;
  /** email of the assignee or empty string to unassign */
  newAssignedTo: string;
  statisticsId: string;
}

export interface UpdateIssueAssignedToResponse {
  assignedTo: string;
  assignedToNotified: boolean;
}

export interface LostConversionFunnel {
  funnelId: string;
  funnelName: string;
  conversionsLost: protobuf.int64;
  opportunity: alexa.Opportunity | null;
}

export enum SeverityCalculationScore {
  SEVERITY_CALCULATION_SCORE_INVALID = 0,
  SEVERITY_CALCULATION_SCORE_LOW = 1,
  SEVERITY_CALCULATION_SCORE_MEDIUM = 2,
  SEVERITY_CALCULATION_SCORE_HIGH = 3
}

export interface SeverityInfo {
  severity: Severity;
  insightInstanceId: string;
  userEmail: string;
  source: SeveritySource;
  createdAt: protobuf.timestamp | null;
  reason: string;
}

export interface PageArgs {
  userId: protobuf.int64;
  sessionId: protobuf.int64;
  pageId: protobuf.int64;
  pageStartTimeMs: protobuf.int64;
  pageOffsetMs: protobuf.int64;
}

export enum MetricTypes {
  METRIC_TYPE_UNKNOWN = 0,
  METRIC_TYPE_CONSOLE_ERROR = 1,
  METRIC_TYPE_ERROR_CLICK = 2,
  METRIC_TYPE_RAGE_CLICK = 3,
  METRIC_TYPE_DEAD_CLICK = 4,
  METRIC_TYPE_REFRESHED_PAGE = 5,
  METRIC_TYPE_NETWORK_ERROR = 6,
  METRIC_TYPE_UNCAUGHT_EXCEPTION = 7,
  METRIC_TYPE_APP_CRASH = 8,
  METRIC_TYPE_ABANDONED_FORM = 9
}

export interface InsightTimeRanges {
  /** Start time of the first instance of the insight (earliest time that exists) */
  insightStartTime: protobuf.timestamp | null;
  /** 24 hours after the start time of the first instance */
  insightFirstInstanceEndTime: protobuf.timestamp | null;
  /** current instance start time */
  instanceStartTime: protobuf.timestamp | null;
  /** current instance end time */
  instanceEndTime: protobuf.timestamp | null;
}

export interface IssueListRow {
  issueId: string;
  instanceId: string;
  title: string;
  description: string;
  /**
   * @deprecated
   * 
   * @deprecated
   */
  lastSpike: protobuf.timestamp | null;
  /**
   * @deprecated
   * 
   * @deprecated
   */
  lostConversionFunnel: LostConversionFunnel | null;
  lostConversionFunnels: LostConversionFunnel[];
  /**
   * @deprecated
   * 
   * @deprecated
   */
  unnamedMetricHash: string;
  pageArgs?: PageArgs | null;
  thumbnailUrl?: string;
  severity: SeverityInfo | null;
  scopedUserPercentage: IssueListRow.ScopedUserPercentage | null;
  issueStatus: IssueStatus;
  descriptionV1: string;
  blocking: boolean;
  errorScore: SeverityCalculationScore;
  frictionScore: SeverityCalculationScore;
  userCountMetric: search_settings.Metric | null;
  metricType: MetricTypes;
  insightTimeRanges: InsightTimeRanges | null;
}

export namespace IssueListRow {
  export interface ScopedUserPercentage {
    percentage: number;
    pageId: protobuf.int64;
    domain: string;
  }

  /**
   * The 3 ways this can play out:
   * 
   * 1. Has page args but no thumbnail url - use the playback renderer
   * 2. Has thumbnail url but not page args - load the thumbnail from gcs
   * 3. Has neither (legacy issues) - fetch all the info necessary from the unnamed metric and use the playback renderer
   */
  export enum render_args {
    pageArgs = 11,
    thumbnailUrl = 12
  }

  /**
   * The 3 ways this can play out:
   * 
   * 1. Has page args but no thumbnail url - use the playback renderer
   * 2. Has thumbnail url but not page args - load the thumbnail from gcs
   * 3. Has neither (legacy issues) - fetch all the info necessary from the unnamed metric and use the playback renderer
   */
  export function render_args_oneof(m: IssueListRow): { opt: render_args.pageArgs, val: PageArgs } | { opt: render_args.thumbnailUrl, val: string } | null {
    if (m.pageArgs != null) { return { opt: render_args.pageArgs, val: m.pageArgs } }
    if (m.thumbnailUrl != null) { return { opt: render_args.thumbnailUrl, val: m.thumbnailUrl } }
    return null;
  }
}

export interface GetIssueDetailViewRequest {
  orgId: string;
  instanceId: string;
}

export interface GetIssueDetailViewResponse {
  title: string;
  description: string;
  /**
   * the start time of the first insight instance
   * @deprecated
   * 
   * @deprecated
   */
  insightStartTime: protobuf.timestamp | null;
  /**
   * the end time of the first insight instance (likely 24 hours after the start time)
   * @deprecated
   * 
   * @deprecated
   */
  insightFirstSeenTime: protobuf.timestamp | null;
  /**
   * the instance's time range
   * @deprecated
   * 
   * @deprecated
   */
  timeRange: segment.TimeRange | null;
  metric: metrics.Metric | null;
  display: display.Display | null;
  lostConversionFunnels: LostConversionFunnel[];
  scopedPageId: number;
  scopedDomain: string;
  severity: SeverityInfo | null;
  /** if false the record will never be the latest. if true it's possible for this instance to become not the latest after the next cron checks for updates */
  isLatestInstance: boolean;
  issueOverview: string;
  issueStatus: IssueStatus;
  /** @deprecated */
  pageArgs?: PageArgs | null;
  /** @deprecated */
  thumbnailUrl?: string;
  /** email of the assignee */
  assignedTo: string;
  noteCount: number;
  descriptionV1: string;
  metricType: MetricTypes;
  insightTimeRanges: InsightTimeRanges | null;
}

export namespace GetIssueDetailViewResponse {
  /** @deprecated render arguments for the instance should be fetched separately */
  export enum render_args {
    /** @deprecated */
    pageArgs = 15,
    /** @deprecated */
    thumbnailUrl = 16
  }

  /** @deprecated render arguments for the instance should be fetched separately */
  export function render_args_oneof(m: GetIssueDetailViewResponse): { opt: render_args.pageArgs, val: PageArgs } | { opt: render_args.thumbnailUrl, val: string } | null {
    if (m.pageArgs != null) { return { opt: render_args.pageArgs, val: m.pageArgs } }
    if (m.thumbnailUrl != null) { return { opt: render_args.thumbnailUrl, val: m.thumbnailUrl } }
    return null;
  }
}

export interface UpdateSeverityRequest {
  severity: Severity;
  feedback: SeverityFeedback;
  orgId: string;
  instanceId: string;
  reason: string;
}

export interface UpdateSeverityResponse {
  severity: Severity;
  instanceId: string;
}

export enum SeverityFeedback {
  SEVERITY_FEEDBACK_INVALID = 0,
  SEVERITY_FEEDBACK_AGREE = 1,
  SEVERITY_FEEDBACK_DISAGREE = 2
}

export enum InsightType {
  INSIGHT_TYPE_UNKNOWN = 0,
  INSIGHT_TYPE_ANOMALY = 1,
  INSIGHT_TYPE_MEAN = 2
}

export interface NewSpotlightDimensionInsightTask {
  orgId: string;
  /** ID of the proactive metric which generated the insight */
  proactiveMetricId: string;
  type: InsightType;
  endTime: protobuf.timestamp | null;
  description: string;
  percentChange: number;
  /** mainly required for mean insights in order to dedup */
  spikingValue: number;
  group: metrics.DataRowGroup | null;
  taskCreatedAt: protobuf.timestamp | null;
}

export enum BaselineDirection {
  BASELINE_DIRECTION_INVALID = 0,
  BASELINE_DIRECTION_WITHIN = 1,
  BASELINE_DIRECTION_BELOW = 2,
  BASELINE_DIRECTION_ABOVE = 3
}

export interface StatData {
  value: number;
  mean: number;
  stdDev: number;
  weeksAgo: number;
  zScore: number;
  baselineDirection: BaselineDirection;
}

export interface NewSpotlightFunnelInsightTask {
  orgId: string;
  /** dx-object id of the funnel */
  funnelDxId: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
  description: string;
  timeToComplete: protobuf.duration | null;
  startStep: number;
  endStep: number;
  endStepCount: number;
  conversionStatData: StatData | null;
  entranceStatData: StatData | null;
}

export interface SpotlightDimensionInsightLog {
  orgId: string;
  metricId: string;
  type: InsightType;
  group: string;
  endTime: protobuf.timestamp | null;
  description: string;
  percentChange: number;
  unnamedMetricUrl: string;
  spotlightUrl: string;
  userCount: number;
  passesChecks: boolean;
  eventCount: number;
  sessionCount: number;
  userPercentage: number;
  pageBreakdown: string;
  deviceBreakdown: string;
  llmOutput: string;
  impact: number;
  objectName: string;
  errorRateChange: number;
  frustrationRateChange: number;
  opportunityFunnels: string[];
  opportunityConversionsLost: protobuf.int64[];
  opportunityConversionDelta: number[];
  avgEventsAfterImpact: number;
  avgSessionPositionPercent: number;
  avgSessionTimeToEvent: number;
  isThirdParty: boolean;
  host: string;
  scopedUserPercentage: number;
  scopedPageId: number;
  scopedDomain: string;
  severity: Severity;
  noisy: boolean;
  issueOverview: string;
}

export interface SpotlightSeverityLog {
  orgId: string;
  metricId: string;
  type: InsightType;
  group: string;
  endTime: protobuf.timestamp | null;
  description: string;
  percentChange: number;
  unnamedMetricUrl: string;
  spotlightUrl: string;
  userCount: number;
  eventCount: number;
  sessionCount: number;
  userPercentage: number;
  pageBreakdown: string;
  deviceBreakdown: string;
  llmOutput: string;
  impact: number;
  objectName: string;
  errorRateChange: number;
  frustrationRateChange: number;
  opportunityFunnels: string[];
  opportunityConversionsLost: protobuf.int64[];
  opportunityConversionDelta: number[];
  avgEventsAfterImpact: number;
  avgSessionPositionPercent: number;
  avgSessionTimeToEvent: number;
  isThirdParty: boolean;
  host: string;
  scopedUserPercentage: number;
  scopedErrorPercentage: number;
  scopedPageId: number;
  scopedDomain: string;
  severity: Severity;
  severityUserEmail: string;
  source: SeveritySource;
  agree: SeverityFeedback;
  severityFeedback: string;
  severityDiff: number;
  prevSeverity: Severity;
  noisy: boolean;
}

export interface GenerateInsightRequest {
  /** optional: all values are defaulted to valid ones in code */
  insightTask: NewSpotlightDimensionInsightTask | null;
}

export interface GenerateFunnelInsightRequest {
  dxFunnelId: string;
  /** we could look this number up --but this is for local dev, so easier to just pass it in */
  stepCount: number;
  hoursToBackfill: number;
}

export interface BackfillSpotlightInsightsRequest {
  /** optional: defaulted to local */
  orgId: string;
  /** optional: defaulted to 1 */
  numRecordsPerBackfill: protobuf.int64;
}

export interface GetInsightNotesRequest {
  insightId: string;
  orgId: string;
  statisticId: string;
}

export interface GetInsightNotesResponse {
  notes: InsightNote[];
}

export interface CreateNoteRequest {
  id: string;
  insightId: string;
  orgId: string;
  note: string;
  statisticId: string;
}

export interface UpdateNoteRequest {
  id: string;
  orgId: string;
  note: string;
}

export interface DeleteNoteRequest {
  id: string;
  orgId: string;
}

export interface InsightNote {
  id: string;
  note: string;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
}

export interface GetInstanceRenderArgsRequest {
  orgId: string;
  instanceIds: string[];
}

export interface InstanceRenderMap {
  url?: string;
  args?: PageArgs | null;
  instanceId: string;
}

export namespace InstanceRenderMap {
  export enum thumbnail_url_or_page_args {
    url = 1,
    args = 2
  }

  export function thumbnail_url_or_page_args_oneof(m: InstanceRenderMap): { opt: thumbnail_url_or_page_args.args, val: PageArgs } | { opt: thumbnail_url_or_page_args.url, val: string } | null {
    if (m.url != null) { return { opt: thumbnail_url_or_page_args.url, val: m.url } }
    if (m.args != null) { return { opt: thumbnail_url_or_page_args.args, val: m.args } }
    return null;
  }
}

export interface GetInstanceRenderArgsResponse {
  instanceRenderArgs: InstanceRenderMap[];
}

export interface CreateInsightIgnoreRuleRequest {
  orgId: string;
  insightId: string;
  metricId: string;
  regex: string;
  markInstancesAsWontFix: boolean;
}

export interface DeleteInsightIgnoreRuleRequest {
  orgId: string;
  ruleId: string;
}

export interface GetInsightIgnoreRulesRequest {
  orgId: string;
}

export interface GetInsightIgnoreRulesResponse {
  rules: InsightIgnoreRule[];
}

export interface InsightIgnoreRule {
  id: string;
  insightId: string;
  metricId: string;
  regex: string;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
}

export interface IsInsightIgnoredRequest {
  orgId: string;
  groupId: string;
  groupIdFallback: boolean;
  metricId: string;
}

export interface PreviewInsightIgnoreRuleRequest {
  orgId: string;
  insightId: string;
  metricId: string;
  regex: string;
  lastSeen: protobuf.timestamp | null;
  pageInfo: pagination.PageInfoRequest | null;
}

export interface PreviewInsightIgnoreRuleResponse {
  ignoredInsights: IgnoredInsight[];
  totalInsights: number;
}

export interface IgnoredInsight {
  insightId: string;
  instanceId: string;
  title: string;
  instanceStartTime: protobuf.timestamp | null;
  instanceEndTime: protobuf.timestamp | null;
}

export interface IsInsightIgnoredResponse {
  isIgnored: boolean;
}
